var amdi18n={"__root":{"run_empty_devicegroup_pt1":"There are no Development Devices device groups available to run and test your code.","run_empty_devicegroup_pt2":"Go to the Devices menu","run_empty_devicegroup_pt3":"above, create a new Development Devices device group and assign a device to it, then return here to run and test the code.","run":"Run","select_device_group":"Select Device Group","run_if_no_dev_devicegroups_pt1":"There are no Development Device Groups available to run and test your code.","run_if_no_dev_devicegroups_pt2":"Go to the Device Group tab, create a Development Device Group, then assign a device to the new device group to test your code.","log_limit":"You've reached 1000 lines of logs, and your older logs will be trimmed","syntax_check_failed":"Syntax check failed.","logging_muted":"Logging muted","logging_unmuted":"Logging unmuted"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;